import { jsxs, jsx } from 'react/jsx-runtime';
import Icon from './Icon.js';

var ToolbarBackIcon = Icon(jsxs("g", { transform: "translate(-71 -311)", children: [jsx("rect", { width: "20", height: "20", transform: "translate(71 311)", fill: "none" }), jsx("g", { transform: "translate(74 314)", children: jsx("g", { children: jsx("path", { d: "M14.754,6.141h-9.3L8.848,2.61A1.466,1.466,0,0,0,7.017.32l-.1.086a1.241,1.241,0,0,0-.127.127L0,7.612l6.809,\r\n        6.937a1.454,1.454,0,0,0,1.031.436h.011A1.464,1.464,0,0,0,8.9,12.5L5.559,9.073h9.195Z" }) }) })] }), '0 0 20 20', 'ToolbarBackIcon');

export { ToolbarBackIcon as default };
